export default __webpack_public_path__ + "static/heroSylas-228af178e4af7ccf9d20044c1d52686f.png";